// Turns a plain-text job description into React elements, treating lines that
// start with "- " or "• " as bullet list items. No HTML parsing/injection —
// every line is rendered as plain text inside <p>/<li>, never dangerouslySetInnerHTML.
const BULLET_RE = /^(-|•)\s+/;

export function renderJobDescription(text) {
  if (!text) return null;

  const blocks = [];
  let listItems = null;
  let paragraphLines = null;

  const flushParagraph = () => {
    if (paragraphLines) {
      blocks.push({ type: 'p', lines: paragraphLines });
      paragraphLines = null;
    }
  };
  const flushList = () => {
    if (listItems) {
      blocks.push({ type: 'ul', items: listItems });
      listItems = null;
    }
  };

  for (const rawLine of text.split('\n')) {
    if (BULLET_RE.test(rawLine)) {
      flushParagraph();
      listItems = listItems || [];
      listItems.push(rawLine.replace(BULLET_RE, ''));
    } else {
      flushList();
      if (rawLine.trim() === '') {
        flushParagraph();
      } else {
        paragraphLines = paragraphLines || [];
        paragraphLines.push(rawLine);
      }
    }
  }
  flushList();
  flushParagraph();

  return blocks.map((block, i) => (
    block.type === 'ul' ? (
      <ul key={i} style={{ margin: '0 0 10px', paddingLeft: '20px' }}>
        {block.items.map((item, j) => <li key={j} style={{ marginBottom: '4px' }}>{item}</li>)}
      </ul>
    ) : (
      <p key={i} style={{ margin: '0 0 10px', whiteSpace: 'pre-wrap' }}>{block.lines.join('\n')}</p>
    )
  ));
}
